import styled from "styled-components";
import { space } from "metabase/styled-components/theme";

export const AlertModalFooter = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
  margin-top: ${space(3)};
`;
